var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { "on-return": () => _vm.$router.go(-1), page: _vm.page }
      }),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } }),
      _vm._l(_vm.itemsPaginated, function(result, idx) {
        return _c(
          "callout",
          {
            key: idx,
            staticClass: "mb-3",
            attrs: {
              "border-color": _vm.getStatusColor(result.admissionStatusId),
              "has-toggle": false
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-12 d-flex align-items-center col-md-2 border-right"
                },
                [
                  _c("balloon", {
                    attrs: {
                      bg: `text-center font-14 border-none bg-${_vm.getStatusColor(
                        result.admissionStatusId
                      )}`,
                      text: result.admissionStatusName
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "col-sm" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm" }, [
                    _c("span", { staticClass: "data-label" }, [
                      _vm._v("Ocurrido:")
                    ]),
                    _c("p", { staticClass: "data" }, [
                      _vm._v(_vm._s(_vm._f("date")(result.dateOfAction)))
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm" }, [
                    _c("span", { staticClass: "data-label" }, [
                      _vm._v("Compañía:")
                    ]),
                    _c("p", { staticClass: "data" }, [
                      _vm._v(_vm._s(result.companyName))
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm" }, [
                    _c("span", { staticClass: "data-label" }, [
                      _vm._v("Centro:")
                    ]),
                    _c("p", { staticClass: "data" }, [
                      _vm._v(_vm._s(result.centeR_NAME))
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm" }, [
                    _c("span", { staticClass: "data-label" }, [
                      _vm._v("Cambiado por:")
                    ]),
                    _c("p", { staticClass: "data" }, [
                      _vm._v(_vm._s(result.actionUserName))
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row" }, [
                  result.admissionDate
                    ? _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v("Fecha de Admisión:")
                        ]),
                        _c("p", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm._f("date")(result.admissionDate)))
                        ])
                      ])
                    : _vm._e(),
                  result.specialist
                    ? _c("div", { staticClass: "col-sm" }, [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v("Especialista:")
                        ]),
                        _c("p", { staticClass: "data" }, [
                          _vm._v(_vm._s(result.specialist))
                        ])
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "row" }, [
                  result.admissionStatusId == _vm.statuses.NoVinculado &&
                  result.admissionStatusReasonId == _vm.rejectedByProvider
                    ? _c("div", { staticClass: "col-sm-12 col-md-12" }, [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v("Razón del rechazo:")
                        ]),
                        _c("p", { staticClass: "data" }, [
                          _vm._v(_vm._s(result.referralDenyReason))
                        ])
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "row" }, [
                  result.admissionStatusId == _vm.statuses.NoVinculado &&
                  result.admissionStatusReasonId == _vm.rejectedByProvider
                    ? _c("div", { staticClass: "col-sm-12 col-md-12" }, [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v("Comentario del rechazo:")
                        ]),
                        _c("p", { staticClass: "data" }, [
                          _vm._v(_vm._s(result.referralDenyComment))
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      }),
      _vm.results.vwThrpyLastAdmissionHistory.length > _vm.paginationData.count
        ? _c("pagination", {
            attrs: { data: _vm.pagination },
            on: {
              "pagination-go-page": function($event) {
                _vm.paginationData.currentPage = $event
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }